// Automation connectors for integrations
// freeConnectors: external links that guide users to setup their own automation
export const freeConnectors = [
  {
    id: 'zapier',
    name: 'Zapier',
    icon: '⚡',
    description: 'Connect to 5000+ apps via Zapier',
    category: 'Automation',
    setupUrl: 'https://zapier.com'
  },
  {
    id: 'make',
    name: 'Make (Integromat)',
    icon: '🔧',
    description: 'Visual automation platform',
    category: 'Automation',
    setupUrl: 'https://make.com'
  }
];

// paidConnectors: native integrations — coming in a future release
export const paidConnectors = [
  { id: 'google-sheets', name: 'Google Sheets', icon: '📊', description: 'Export content to spreadsheets', category: 'Productivity' },
  { id: 'notion',        name: 'Notion',         icon: '📝', description: 'Save to Notion workspace',       category: 'Productivity' },
  { id: 'wordpress',     name: 'WordPress',      icon: '✍️', description: 'Publish directly to WordPress',  category: 'Content' },
  { id: 'mailchimp',     name: 'Mailchimp',      icon: '📧', description: 'Send to email list',             category: 'Marketing' },
  { id: 'slack',         name: 'Slack',          icon: '💬', description: 'Post to Slack channels',         category: 'Communication' },
  { id: 'discord',       name: 'Discord',        icon: '🎮', description: 'Send to Discord servers',        category: 'Communication' },
  { id: 'hubspot',       name: 'HubSpot',        icon: '🎯', description: 'Push to CRM contacts',           category: 'CRM' },
  { id: 'airtable',      name: 'Airtable',       icon: '🗂️', description: 'Save to Airtable base',          category: 'Database' },
  { id: 'mailerlite',    name: 'MailerLite',     icon: '💌', description: 'Email campaign automation',      category: 'Marketing' },
  { id: 'buffer',        name: 'Buffer',         icon: '📅', description: 'Schedule social media posts',    category: 'Social' },
];
